import { Card } from "@/components/ui";
import { InfoIcon } from "@/components/icons";
import { cn } from "@/lib/utils";
import { ActionIcon, Button, Title, Tooltip } from "rizzui";
import { MdArrowForwardIos } from "react-icons/md";

interface CreditBalanceCardProps {
  title: string;
  amount: number;
  tooltipContent: string;
  onTopUp: () => void;
  className?: string;
}

export default function CreditBalanceCard({
  title,
  amount,
  tooltipContent,
  onTopUp,
  className,
}: CreditBalanceCardProps) {
  return (
    <Card className={cn("p-6 h-full", className)}>
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-start mb-2">
          <Title as="h3" className="text-2xl font-bold">
            {amount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Title>
          <Tooltip
            size="sm"
            content={<div className="w-40 text-start">{tooltipContent}</div>}
            placement="bottom-start"
            color="invert"
            className="max-w-[300px]"
          >
            <ActionIcon size="sm" variant="text">
              <InfoIcon className="h-5 w-5 text-gray-400" />
            </ActionIcon>
          </Tooltip>
        </div>

        <p className="text-gray-600 mb-6 font-bold">{title}</p>

        <div className="mt-auto">
          <Button
            variant="outline"
            className="flex items-center justify-center gap-2 border-gray-200 font-bold"
            onClick={onTopUp}
          >
            Top Up Now
            <MdArrowForwardIos className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Card>
  );
}
